import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { getProducts, deleteProduct } from "../../api/products";
import { formatPrice } from "../ProductForm/productUtils";
import "./style.css";

const Products = () => {
	const navigate = useNavigate();
	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState("");
	const [deleteTarget, setDeleteTarget] = useState(null);
	const [deleting, setDeleting] = useState(false);

	const tableHeaders = ["", "Görsel", "Ürün Adı", "Tip", "Fiyat", "Durum", ""];

	const loadProducts = async () => {
		try {
			const data = await getProducts();
			setProducts(Array.isArray(data) ? data : []);
		} catch (error) {
			console.error("Ürün verileri getirilirken bir hata oluştu:", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		loadProducts();
	}, []);

	const handleDelete = async () => {
		if (!deleteTarget) return;
		setDeleting(true);
		try {
			await deleteProduct(deleteTarget._id);
			setProducts((prev) => prev.filter((p) => p._id !== deleteTarget._id));
			setDeleteTarget(null);
		} catch (error) {
			console.error("Silme işlemi sırasında bir hata oluştu:", error);
			alert(error.message || "Ürün silinirken bir hata oluştu");
		} finally {
			setDeleting(false);
		}
	};

	const filteredProducts = products.filter((p) =>
		(p.productName || "").toLowerCase().includes(search.toLowerCase())
	);

	return (
		<Layout>
			<div className="products-wrapper">
				<div className="device-table-wrapper">
					<div className="device-filter-inputs">
						<Form.Group>
							<Form.Control
								type="text"
								placeholder="Ürün ara..."
								value={search}
								onChange={(e) => setSearch(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Button variant="primary" onClick={() => navigate("/products/new")}>
								Ürün Ekle
							</Button>
						</Form.Group>
					</div>
					<Table striped bordered hover responsive className="alarm-table">
						<thead>
							<tr>
								{tableHeaders.map((header, index) => (
									<th key={index}>{header}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan={tableHeaders.length} style={{ textAlign: "center" }}>
										<Spinner animation="border" variant="primary" />
									</td>
								</tr>
							) : filteredProducts.length > 0 ? (
								filteredProducts.map((product, index) => (
									<tr key={product._id || index}>
										<td className="table-id">{index + 1}</td>
										<td>
											{product.productImage ? (
												<img
													src={product.productImage}
													alt={product.productName}
													className="product-thumb"
												/>
											) : (
												<div className="product-thumb product-thumb-empty">-</div>
											)}
										</td>
										<td>
											<Link to={`/products/${product._id}`}>
												{product.productName || "-"}
											</Link>
										</td>
										<td>
											<span
												className={`product-type-badge ${
													product.productType === "instant" ? "instant" : "shipping"
												}`}
											>
												{product.productType === "instant"
													? "Anlık Teslim"
													: "Kargolanacak"}
											</span>
										</td>
										<td>{formatPrice(product.productPrice, product.productCurrency)}</td>
										<td>
											<span
												className={`product-status ${
													product.productActive === "Pasif" ? "passive" : "active"
												}`}
											>
												{product.productActive || "Aktif"}
											</span>
										</td>
										<td className="product-actions">
											<Link to={`/products/${product._id}`}>Düzenle</Link>
											<Button
												variant="link"
												size="sm"
												className="text-danger p-0"
												onClick={() => setDeleteTarget(product)}
											>
												Sil
											</Button>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={tableHeaders.length} style={{ textAlign: "center" }}>
										{search
											? "Aramanızla eşleşen ürün bulunamadı."
											: "Henüz ürün bulunmamaktadır."}
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</div>
			<Modal show={!!deleteTarget} onHide={() => setDeleteTarget(null)}>
				<Modal.Header closeButton>Ürünü Sil</Modal.Header>
				<Modal.Body>
					<strong>{deleteTarget?.productName}</strong> ürününü silmek istediğinize
					emin misiniz? Bu işlem geri alınamaz.
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setDeleteTarget(null)}>
						İptal
					</Button>
					<Button variant="danger" onClick={handleDelete} disabled={deleting}>
						{deleting ? (
							<>
								<Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
								Siliniyor...
							</>
						) : (
							"Sil"
						)}
					</Button>
				</Modal.Footer>
			</Modal>
		</Layout>
	);
};

export default Products;
